<template>
  <div>
    <el-table :data="data" ref="table_view" height="calc(100vh - 120px)">
      <el-table-column prop="timestamp" :label="$t('base.timestamp')" min-width="150px"
                       v-if="m__is_show_index('impression')" sortable>
        <template slot-scope="scope">
          {{ scope.row.timestamp * 1000 | moment('DD-MM-YYYY HH:mm') }}

          <div v-if="is_compare" style="font-size: 12px">
            <span class="text-danger">
              {{
                m__find_compare_data(scope.row.index, scope.row.timestamp, 'timestamp') * 1000 | moment('DD-MM-YYYY HH:mm', '-')
              }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="show_extend" prop="daily_quota" :label="$t('base.daily_budget')" width="140px" sortable>
        <template slot-scope="scope">
          {{ m__get_report_property(scope.row, 'daily_quota') | currency }}

          <div v-if="is_compare" style="font-size: 12px">
            <span class="text-danger">
              {{ m__find_compare_data(scope.row.index, scope.row.timestamp, 'daily_quota') | currency(false) }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="show_extend" prop="roi_two_target" :label="$t('base.target_roas')" width="130px" sortable>
        <template slot-scope="scope">
          {{ m__get_report_property(scope.row, 'roi_two_target') | to_fixed(1, 0) }}

          <div v-if="is_compare" style="font-size: 12px">
            <span class="text-danger">
              {{ m__find_compare_data(scope.row.index, scope.row.timestamp, 'roi_two_target') | to_fixed(1, '-') }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="avg_rank" :label="$t('metric.average_ranking')"
                       width="130px" sortable>
        <template slot-scope="scope">
          {{ m__get_report_property(scope.row, 'avg_rank') | currency }}

          <div v-if="is_compare" style="font-size: 12px">
            <span class="text-danger">
              {{ m__find_compare_data(scope.row.index, scope.row.timestamp, 'avg_rank') | currency(false) }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="impression" :label="$t('metric.impressions')" width="120px"
                       v-if="m__is_show_index('impression')" sortable>
        <template slot-scope="scope">
          {{ m__get_report_property(scope.row, 'impression') | currency }}

          <div v-if="is_compare" style="font-size: 12px">
            <span class="text-danger">
              {{ m__find_compare_data(scope.row.index, scope.row.timestamp, 'impression') | currency(false) }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="click" :label="$t('metric.clicks')" width="120px"
                       v-if="m__is_show_index('click')"
                       sortable>
        <template slot-scope="scope">
          {{ m__get_report_property(scope.row, 'click') | currency }}

          <div v-if="is_compare" style="font-size: 12px">
            <span class="text-danger">
              {{ m__find_compare_data(scope.row.index, scope.row.timestamp, 'click') | currency(false) }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="ctr" :label="$t('metric.ctr')" width="100px" v-if="m__is_show_index('ctr')"
                       sortable>
        <template slot-scope="scope">
          {{ (m__get_report_property(scope.row, 'ctr') * 100) | to_fixed(1, 0) }}%

          <div v-if="is_compare" style="font-size: 12px">
            <span class="text-danger">
              {{ (m__find_compare_data(scope.row.index, scope.row.timestamp, 'ctr') * 100) | to_fixed(1, '-') }}%
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="broad_order" :label="$t('metric.checkout')" width="120px"
                       v-if="m__is_show_index('broad_order')" sortable>
        <template slot-scope="scope">
          {{ m__get_report_property(scope.row, 'broad_order') | currency }}

          <div v-if="is_compare" style="font-size: 12px">
            <span class="text-danger">
              {{ m__find_compare_data(scope.row.index, scope.row.timestamp, 'broad_order') | currency(false) }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="broad_order_amount" :label="$t('metric.items_sold')" width="150px"
                       v-if="m__is_show_index('broad_order_amount')" sortable>
        <template slot-scope="scope">
          {{ m__get_report_property(scope.row, 'broad_order_amount') | currency }}

          <div v-if="is_compare" style="font-size: 12px">
            <span class="text-danger">
              {{ m__find_compare_data(scope.row.index, scope.row.timestamp, 'broad_order_amount') | currency(false) }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="broad_gmv" label="GMV" width="120px" v-if="m__is_show_index('broad_gmv')"
                       sortable>
        <template slot-scope="scope">
          {{ m__calculate(m__get_report_property(scope.row, 'broad_gmv')) | currency }}

          <div v-if="is_compare" style="font-size: 12px">
            <span class="text-danger">
              {{ m__find_compare_data(scope.row.index, scope.row.timestamp, 'broad_gmv') | currency(false) }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="show_extend && m__is_show_index('broad_gmv')" prop="broad_gmv" label="% GMV"
                       width="120px" sortable>
        <template slot-scope="scope">
          {{ m__get_report_property(scope.row, 'broad_gmv_percent') | to_fixed(1, 0) }}%

          <div v-if="is_compare" style="font-size: 12px">
            <span class="text-danger">
              {{ m__find_compare_data(scope.row.index, scope.row.timestamp, 'broad_gmv_percent') | to_fixed(1, '-') }}%
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cost" :label="$t('metric.expense')" width="120px" v-if="m__is_show_index('cost')"
                       sortable>
        <template slot-scope="scope">
          {{ m__calculate(m__get_report_property(scope.row, 'cost')) | currency }}

          <div v-if="is_compare" style="font-size: 12px">
            <span class="text-danger">
              {{ m__find_compare_data(scope.row.index, scope.row.timestamp, 'cost') | currency(false) }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="show_extend && m__is_show_index('cost')" prop="cost" :label="'% ' + $t('metric.expense')"
                       width="120px" sortable>
        <template slot-scope="scope">
          {{ m__get_report_property(scope.row, 'cost_percent') | to_fixed(1, 0) }}%

          <div v-if="is_compare" style="font-size: 12px">
            <span class="text-danger">
              {{ m__find_compare_data(scope.row.index, scope.row.timestamp, 'cost_percent') | to_fixed(1, '-') }}%
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="atosa_cpc" label="CPC" width="120px" v-if="m__is_show_index('click')" sortable>
        <template slot-scope="scope">
          {{ m__get_report_property(scope.row, 'atosa_cpc') | currency }}

          <div v-if="is_compare" style="font-size: 12px">
            <span class="text-danger">
              {{ m__find_compare_data(scope.row.index, scope.row.timestamp, 'atosa_cpc') | currency(false) }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="broad_cir" label="CIR (ACOS)" width="120px" v-if="m__is_show_index('broad_cir')"
                       sortable>
        <template slot-scope="scope">
          {{ (m__get_report_property(scope.row, 'broad_cir') * 100) | to_fixed(1, 0) }}%

          <div v-if="is_compare" style="font-size: 12px">
            <span class="text-danger">
              {{ (m__find_compare_data(scope.row.index, scope.row.timestamp, 'broad_cir') * 100) | to_fixed(1, '-') }}%
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="broad_roi" label="ROI (ROAS)" width="120px" v-if="m__is_show_index('broad_roi')"
                       sortable>
        <template slot-scope="scope">
          {{ m__get_report_property(scope.row, 'broad_roi') | to_fixed(1, 0) }}

          <div v-if="is_compare" style="font-size: 12px">
            <span class="text-danger">
              {{ m__find_compare_data(scope.row.index, scope.row.timestamp, 'broad_roi') | to_fixed(1, '-') }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cpm" label="CPM" width="120px" v-if="m__is_show_index('cost')"
                       sortable>
        <template slot-scope="scope">
          {{ m__get_report_property(scope.row, 'cpm') | currency }}

          <div v-if="is_compare" style="font-size: 12px">
            <span class="text-danger">
              {{ m__find_compare_data(scope.row.index, scope.row.timestamp, 'cpm') | currency(false) }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cr" :label="$t('metric.conversion_rate')" width="140px" v-if="m__is_show_index('cr')"
                       sortable>
        <template slot-scope="scope">
          {{ (m__get_report_property(scope.row, 'cr') * 100) | to_fixed(1, 0) }}%

          <div v-if="is_compare" style="font-size: 12px">
            <span class="text-danger">
              {{ (m__find_compare_data(scope.row.index, scope.row.timestamp, 'cr') * 100) | to_fixed(1, '-') }}%
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="exclude_cancelled_gmv" :label="$t('metric.exclude_cancelled_gmv')" width="120px"
                       v-if="m__is_show_index('exclude_cancelled_gmv')" sortable>
        <template slot-scope="scope">
          {{ m__calculate(m__get_report_property(scope.row, 'exclude_cancelled_gmv')) | currency }}

          <div v-if="is_compare" style="font-size: 12px">
            <span class="text-danger">
              {{
                m__find_compare_data(scope.row.index, scope.row.timestamp, 'exclude_cancelled_gmv') | currency(false)
              }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="exclude_cancelled_roi" :label="$t('metric.exclude_cancelled_roi')" width="120px"
                       v-if="m__is_show_index('exclude_cancelled_roi')" sortable>
        <template slot-scope="scope">
          {{ m__get_report_property(scope.row, 'exclude_cancelled_roi') | to_fixed(1, 0) }}

          <div v-if="is_compare" style="font-size: 12px">
            <span class="text-danger">
              {{
                m__find_compare_data(scope.row.index, scope.row.timestamp, 'exclude_cancelled_roi') | to_fixed(1, '-')
              }}
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {fix_ads_mixins} from '../../../mixins/fix_ads';

export default {
  name: 'component_metric_table_view',

  mixins: [fix_ads_mixins],

  props: {
    shop: {
      type: Object,
      default: () => null
    },
    data: {
      type: Array,
      default: () => []
    },
    is_compare: {
      type: Boolean,
      default: () => true
    },
    compare_data: {
      type: Array,
      default: () => []
    },
    show_extend: {
      type: Boolean,
      default: () => false
    }
  },

  methods: {
    m__get_report_property(data, key) {
      return data[key] ? Number(data[key]) : 0
    },

    m__is_show_index() {
      return true
    },

    m__find_compare_data(index, timestamp, key, default_value = '-') {
      if (!this.compare_data) return default_value

      // const found = this.compare_data.find(i => i.index === index)
      // if (found && +found[key]) return +found[key]
      // else return default_value

      // const found = this.compare_data.find(i => i.index === index)
      // if (found) {
      //   if (
      //     this.dayjs(found.timestamp * 1000).hour() === this.dayjs(timestamp * 1000).hour() &&
      //     this.dayjs(found.timestamp * 1000).minute() === this.dayjs(timestamp * 1000).minute()
      //   ) {
      //     return +found[key]
      //   } else {
      //     return -1
      //   }
      // }

      if (this.data.length === this.compare_data.length) {
        const found = this.compare_data.find(i => i.index === index)
        if (found && +found[key]) return +found[key]
      }

      const keys = ['daily_quota', 'roi_two_target']
      if (keys.includes(key)) {
        const found = this.compare_data.find(i => i.index === index)
        if (found && +found[key]) return +found[key]
      }

      const found = this.compare_data.find(i =>
        this.dayjs(i.timestamp * 1000).hour() === this.dayjs(timestamp * 1000).hour() &&
        this.dayjs(i.timestamp * 1000).minute() === this.dayjs(timestamp * 1000).minute()
      )
      if (found) {
        return +found[key]
      }

      // todo: check if current time end compare time is same day
      // const first_data = this.data[0]
      // const last_data = this.data[this.data.length - 1]
      // const first_compare = this.compare_data[0]
      // const last_compare = this.compare_data[this.compare_data.length - 1]
      //
      // console.log('test', first_data && last_data && first_compare && last_compare &&
      //   this.dayjs(first_data.timestamp * 1000).isSame(this.dayjs(last_data.timestamp * 1000), 'day') &&
      //   this.dayjs(first_compare.timestamp * 1000).isSame(this.dayjs(last_compare.timestamp * 1000), 'day'))
      //
      // if (
      //   first_data && last_data && first_compare && last_compare &&
      //   this.dayjs(first_data.timestamp * 1000).isSame(this.dayjs(last_data.timestamp * 1000), 'day') &&
      //   this.dayjs(first_compare.timestamp * 1000).isSame(this.dayjs(last_compare.timestamp * 1000), 'day')
      // ) {
      // }

      // const found = this.compare_data.find(i => i.index === index)
      // if (found && +found[key]) return +found[key]

      return default_value
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/pas/component/component_metric_table_view.vue